import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Injectable()
export class APIEntityService {
    private balancedays = 0;
    private expiryDays = 0;
    private certExpired = false;

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    public download(file1): Observable<any> {

        return this.http.post(APIConstants.FILEDOWNLOAD, file1, { responseType: "blob" });
    }

    //  public headerFileDownload(file1): Observable<any>{

    //     return this.http.post(APIConstants.FILEDOWNLOAD, file1,{ responseType: "blob"});
    // }

    //  public fetchEntityDetails(data): Observable<any>{
    //     console.log("in service");
    //     return this.http.post(APIConstants.FETCHENTITYDETAILS, data);
    // }


    public getEntitySummaryforApproval(Tsp): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFORAPPROVAL + Tsp);

    }

    public updateEntitySummaryforApproval(data): Observable<any> {
        console.log("inside api update entity");
        let a = this.http.post(APIConstants.UPDATEENTITYDETAILSMONGO, data);
        // console.log("a",a);
        // console.log("a",JSON.stringify(a));
        return a;
        // return this.http.get(APIConstants.INVOKE);

    }

    public getAllEntitySummary(tsp): Observable<any> {
        console.log("inside get all entity");
        return this.http.get(APIConstants.GETENTITYSUMMARY + tsp);
        /*   return this.http.get(APIConstants.GETENTITYSUMMARY+tsp).pipe(map((data: any) => data.result )); */

    }

    public entityIdVerification(entityId): Observable<any> {
        console.log("inside get all entity", entityId);
        let a = this.http.get(APIConstants.VALIDATEENTITYID + entityId);
        console.log("aaaaa /...", a);
        return this.http.get(APIConstants.VALIDATEENTITYID + entityId, { responseType: 'text' });
        // return this.http.get(APIConstants.INVOKE);

    }

    public getComplaintsForVirtualID(): Observable<any> {
        // console.log("inside mob call complaint :",MobileNo);
        let virtual_id = this.db.get(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID);
        let serviceProvider = "RJIO";
        return this.http.get(APIConstants.GETSUBSCRIBERANDPREFERENCEDETAILS + virtual_id + '/' + serviceProvider);
        // return this.http.get(APIConstants.GETSUBSCRIBERCOMPLAINTSBYMOBILENOCOMPLAINTNO+MobileNo);
    }


    private parseRjioComplaints(res: any): any {
        const data = res.reduce((acc, val) => {
            acc.push({
                'Complaint_No': val.Record.Complaint_No,
                'ComplaintDate': val.Record.ComplaintDate,
                'MobileNo': val.Record.MobileNo,
                'TSP_Name': val.Record.TSP_Name,
                'TM_Type': val.Record.TM_Type,
                'IncidentDate': val.Record.IncidentDate,
                'ComplaintDesc': val.Record.ComplaintDesc,
                'Status': val.Record.Status,
                'TM_No_Header': val.Record.TM_No_Header,
                'ProviderDesc': val.Record.ProviderDesc
            });
            return acc;
        }, []);
        console.log("data :", data);
        return data;
    }



    public complaintsSubscriber(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public complaintUpdateByTAP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByOAP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByTSP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public getHeaderData(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        return this.http.get(APIConstants.GET_HEADERS_FOR_APPROVAL + sp)
            .pipe(map(r => this.parseHeaderData(r)))
    }
    public getHeaderDataForTSP(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        let serviceprovider = this.db.get(Constants.SESSSION_STORAGE, Constants.SERVICE_PROVIDER);
        return this.http.get(APIConstants.GETALLHEADERFORTSP + sp)
            .pipe(map(r => this.parseHeaderDataTSP(r)))
    }

    private parseHeaderData(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type
            });
            return acc;
        }, []);
        return modRes;
    }

    private parseHeaderDataTSP(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type,
                'Status': val.Record.Status
            });
            return acc;
        }, []);
        return modRes;
    }

    public approveORReject(headerName: string, status: string): Observable<any> {
        let todayDate = new Date();
        let data = {
            "header": {
                "event_const": "CNST_APPROVE_HEADER_EVENT",
                "head_id": 123
            },
            "jsonblob": {
                "Header_Name": headerName,
                "TSP_Approve_Date": todayDate,
                "Status": status
            }
        }
        return this.http.post(APIConstants.INVOKE, data);
    }


    public getAllEntityForApprovalFilter(param, fdate, ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFORAPPROVALFILTER + param + '/' + fdate + '/' + ldate);

    }

    public getAllEntityFilter(param, fdate, ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFILTER + param + '/' + fdate + '/' + ldate);

    }

    // new entity summary from mongo

    public getAllNewEntitySummaryMongo(status): Observable<any> {
        console.log(" status for checking in service", status)

        return this.http.post(APIConstants.GETENTITYSUMMARYMONGO, status);

    }

    public newGetEntitySummaryMongoExceptTa(status): Observable<any> {
        console.log(" status for checking in service", status)

        return this.http.post(APIConstants.GETENTITYSUMMARYMONGOTA, status);

    }

    //Summary for invite users 

    public getInvitedUserSummary(inviteId): Observable<any> {
        console.log(" inviteId for checking in service", inviteId)

        return this.http.post(APIConstants.INVITEUSER, inviteId);

    }

    //deactivate the entity 
    public deactivateEntitySerive(data): Observable<any> {
        console.log("deactivate the entity service", data)
        return this.http.post(APIConstants.DEACTIVATEENTITY, data)
    }

    public downloadcsv(Status): Observable<any> {
        console.log("batch id issssssssssss", Status)
        return this.http.get(APIConstants.DOWNLOADENTITYDETAILS + '/' + Status, { responseType: "blob" });
    }


    //Content Template 

    public getContentEntityDetails(data): Observable<any> {
        return this.http.post(APIConstants.GETCONTENTENTITYDETAILS, data);
    }
    public templatefiledownload(file1): Observable<any> {
        return this.http.post(APIConstants.TEMPLATEFILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public getTemplateDetails(data): Observable<any> {

        return this.http.post(APIConstants.GETTEMPLATEDETAILS, data);

    }
    public verifyCsTempID(data: any): Observable<any> {
        console.log("serive file ------------- ", data);
        return this.http.post(APIConstants.VERIFYCSTEMPID, data);
    }

    //Consent

    // New Consent Template request by PE
    public newConsentTemplate(data): Observable<any> {
        return this.http.post(APIConstants.POSTCSTNEWTEMPLATEREQUEST, data);
    }


    public GetNewConsentTemplate(data): Observable<any> {
        return this.http.get(APIConstants.GETCSTNEWTEMPLATEREQUEST + '/' + data);
    }

    //Entity UI - Consent Template Reports

    public getCsTemplateReports(data): Observable<any> {
        return this.http.get(APIConstants.GETCSTEMPLATEREPORTS + '/' + data);
    }

    //Post call

    public getAllEntityForApprovalFilters(data): Observable<any> {
        //  return this.http.get(APIConstants.GETCSWORKLISTFiLTERS + param + '/' + fdate + '/' + ldate);
        return this.http.post(APIConstants.GETCSTEMPLATEREPORTSFILTERS, data);
    }

    //download file


    public downloadentitytemplatessvfile(data): Observable<any> {
        console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADTEMPLATEREPORTSSSVFILE, data, { responseType: "blob" });
    }

    public entityConsentTemplate(data): Observable<any> {
        return this.http.post(APIConstants.POSTENTITYCONSENTTEMPLATE, data);
    }


    public GetEntityConsentTemplate(data): Observable<any> {
        return this.http.get(APIConstants.GETENTITYCONSENTTEMPLATE + '/' + data);
    }

    //Consent Template Bulk Upload Summary

    public getCSBulkUploadSummary(id): Observable<any> {
        return this.http.get(APIConstants.GETCSBULKUPLOADSUMMARY + '/' + id);
    }

    //Post call

    public getAllCSBulkUploadSummaryFilter(data): Observable<any> {
        //  return this.http.get(APIConstants.GETCSWORKLISTFiLTERS + param + '/' + fdate + '/' + ldate);
        return this.http.post(APIConstants.GETCSBULKUPLOADSUMMARYFILTERS, data);
    }

    //download file


    public downloadCSBulkUploadSummarysvfile(data): Observable<any> {
        console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADCONSENTBULKSUMMARYSSVFILE, data, { responseType: "blob" });
    }

    //Bulk Consent Template Registration
    public importBulkCSTRegistration(data: any): Observable<any> {
        console.log("serive file ------------- ", data);
        return this.http.post(APIConstants.IMPORTBULKCSTREGISTRATION, data);
    }


    //Bulk Consent Template Registration sample file download
    public consentTemplate(schema): Observable<any> {
        return this.http.get(APIConstants.GETCONSENTTEMPLATE + '/' + schema, { responseType: "blob" });
    }

    //Header_

    public getOneEntityFromMongo(data): Observable<any> {
        return this.http.post(APIConstants.GETONEENTITYDROMMONGO, data);
    }

    //Consent
    public downloadCSEntityConsentReportssvfile(data): Observable<any> {
        console.log("batch id is ", data)
        return this.http.post(APIConstants.DOWNLOADENTITYCONSENTREPORTSSSVFILE, data, { responseType: "blob" });
    }

    public getCSEntityConsentReports(id): Observable<any> {
        return this.http.get(APIConstants.GETCSENTITYCONSENTREPORTS + '/' + id);
    }
    public getAllCSEntityConsentReportsFilter(data): Observable<any> {

        return this.http.post(APIConstants.GETCSENTITYCONSENTREPORTSFILTERS, data);
    }
    // public downloadDLTReport(module): Observable<any> {  

    //     return this.http.get(APIConstants.DOWNLOADDLTREPORT+'/'+ module,{responseType: "blob" });
    // }






    //Entity-phase I
    public getAuditLog(data: any): Observable<any> {
        console.log("serive file ------------- ", data);
        return this.http.post(APIConstants.GETAUDITLOG, data);
    }
    public getEditLog(data: any): Observable<any> {
        console.log("serive file", data);
        return this.http.post(APIConstants.GETEDITLOG, data);
    }

    public resendOtp(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.RESENDOTPchange, data, { headers });
    }
    public changepwdVerification(data): Observable<any> {
        console.log("dataaaaasengathir", data)
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.changePWdVerification, data, { headers });
    }
    public PwdChange(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.PEWCHANGE, data, { headers });
    }

    public resendemailsmsOtp(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.RESENDEmailSmsOTP, data, { headers });
    }
    public ForgetPwdChange(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.FORGOTPEWCHANGE, data, { headers });
    }
    public getProcessRoles(selectedValue): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSROLES + '/' + selectedValue);
    }
    public fetchEntityDetails(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.FETCHENTITYDETAILS, data);
    }
    public getProcessRolesModify(selectedValue, entityID): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSROLESMODIFY + '/' + selectedValue + '/' + entityID);
    }
    public getProcessOwnerDetails(tataID): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSOWNERDETAILS + '/' + tataID);
    }
    public headerFileDownload(file1): Observable<any> {

        return this.http.post(APIConstants.FILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public deleteBlobIfExists(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.DELETEBLOBIFEXISTS, data);
    }
    public tataModification(data: any): Observable<any> {
        return this.http.post(APIConstants.TATAMODIFICATION, data);
    }

    public downloadentitycsvfile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADENTITYCSVFILE, data, { responseType: "blob" });
    }
    public getTtsluserSummaryFilter(data: any): Observable<any> {
        console.log("serive file", data);
        return this.http.post(APIConstants.GETTTSLUSERSUMMARYFILTER, data);
    }
    public getTataSummaryMongo(processrole, status, role): Observable<any> {
        console.log(" status for checking in service", status)
        return this.http.get(APIConstants.GETTATASUMMARYMONGO + '/' + processrole + '/' + status + '/' + role);
    }
    public updateTataSummaryforApproval(data): Observable<any> {
        console.log("inside api update entity");
        let a = this.http.post(APIConstants.UPDATETATADETAILSMONGO, data);
        return a;
    }
    public downloadtatafile(data): Observable<any> {

        return this.http.post(APIConstants.DOWNLOADTATAFILE, data, { responseType: "blob" });
    }
    public getAllTataSummaryMongo(processrole, role): Observable<any> {
        return this.http.get(APIConstants.GETALLTATASUMMARYMONGO + '/' + processrole + '/' + role);
    }

    public getGeTTLUserDetails(tataID): Observable<any> {
        return this.http.get(APIConstants.GETGETTLUSERDETAILS + '/' + tataID);
    }

    public modifyStatus(data: any): Observable<any> {
        return this.http.post(APIConstants.POSTMODIFYSTATUS, data);
    }
    public generateotp(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GENERATEENTITYOTP, data);
    }
    public TMPEentityUpdation(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.TMPEENTITYUPDATION, data, { headers });
    }

    public getDetailsFromURN(data): Observable<any> {
        //  console.log(" status for checking in service",status)
        return this.http.post(APIConstants.GETDETAILSFROMURN, data);
    }

    public getExistingID(data: any): Observable<any> {
        return this.http.post(APIConstants.GETEXISTINGID, data);
    }

    public checkPOInEclass(data: any): Observable<any> {
        return this.http.post(APIConstants.CHECKPOINECLASS, data);
    }

    public sendEMOTP(data: any): Observable<any> {
        return this.http.post(APIConstants.SENDEMOTP, data);
    }

    public checkPOIEmailMobile(data: any): Observable<any> {
        return this.http.post(APIConstants.CHECKPOIEMAILMOBILE, data);
    }

    public urnGenerate(data: any): Observable<any> {
        return this.http.post(APIConstants.URNGENERATE, data);
    }


    public getRegisteredPOI(data: any): Observable<any> {
        return this.http.post(APIConstants.GETREGISTEREDPOI, data);
    }

    public getAllStates(id): Observable<any> {
        return this.http.get(APIConstants.GETALLSTATES + '/' + id);
    }

    public getCitiesByStateName(id): Observable<any> {
        return this.http.get(APIConstants.GETALLCITIESBYSTATENAME + '/' + id);
    }



    public getRegisteredDetails(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.get(APIConstants.GETREGISTEREDDETAILS + '/' + data);

    }

    public getEntityDetailsUrn(data): Observable<any> {
        return this.http.get(APIConstants.GETENTITYDETAILSURN + '/' + data);
    }

    public getEntityDetailsID(data): Observable<any> {
        return this.http.get(APIConstants.GETENTITYDETAILSID + '/' + data);
    }

    public checkPanExists(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.CHECKPANEXISTS, data);

    }

    public modifyFileDownload(file1): Observable<any> {

        return this.http.post(APIConstants.MODIFYFILEDOWNLOAD, file1, { responseType: "blob" });
    }

    public modSendEMOTP(data: any): Observable<any> {
        return this.http.post(APIConstants.MODSENDEMOTP, data);
    }
    public updateEntity(data: any): Observable<any> {
        return this.http.post(APIConstants.UPDATEENTITY, data);
    }

    public getEntityWorklist(status): Observable<any> {
        console.log(" status for checking in service ---  ", status)
        return this.http.post(APIConstants.GETENTITYWORKLIST, status);
    }

    public getWorklistSummaryFilter(data: any): Observable<any> {
        console.log("serive file", data);
        return this.http.post(APIConstants.GETWORKLISTSUMMARYFILTER, data);
    }

    public downloadCSTsvfile(data): Observable<any> {
        console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADENTITYWORKLISTCSVFILE, data, { responseType: "blob" });
    }

    public downloadentityworklistcsvfile(data): Observable<any> {
        console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADENTITYWORKLISTCSVFILE, data, { responseType: "blob" });
    }


    public getReportSummaryFilter(data: any): Observable<any> {
        //  console.log("serive file",data);
        return this.http.post(APIConstants.GETREPORTSUMMARYFILTER, data);
    }

    public getEntityReport(selectedTab): Observable<any> {
        return this.http.get(APIConstants.GETENTITYREPORT + '/' + selectedTab);
    }

    public downloadreportcsvfile(data): Observable<any> {
        //  console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADREPORTCSVFILE, data, { responseType: "blob" });
    }

    public reportFileDownload(file1): Observable<any> {
        return this.http.post(APIConstants.REPORTFILEDOWNLOAD, file1, { responseType: "blob" });
    }

    public BlacklistEntityReport(data): Observable<any> {
        return this.http.post(APIConstants.BLACKLISTENTITYREPORT, data)
    }

    public downloadDLTReport(module): Observable<any> {
        return this.http.get(APIConstants.DOWNLOADDLTREPORT + '/' + module, { responseType: "blob" });
    }
    public downloadDailyReport(module): Observable<any> {

        return this.http.get(APIConstants.DOWNLOADDAILYREPORT + '/' + module, { responseType: "blob" });
    }

    public setpwdexpirydiffdays(DiffDays, entityExpiryDiffDays, hasCertExpired) {
        console.log(" Diffdays for checking in service ---  ", DiffDays)
        this.balancedays = DiffDays
        this.expiryDays = entityExpiryDiffDays
        this.certExpired = hasCertExpired
    }

    public getpwdexpirydiffdays() {
        console.log(" Diffdays for checking in service ---  ", this.balancedays)
        return this.balancedays
    }

    public getCertexpiryFlag() {
        console.log(" Flag for certificate expiry ---  ", this.certExpired)
        return this.certExpired
    }

    public getCertexpirydiffdays() {
        console.log(" expiryDays for checking in service ---  ", this.expiryDays)
        return this.expiryDays
    }

    //pe side - petm binding- surekha
    public petmbindingcreatechain(data: any): Observable<any> {
        return this.http.post(APIConstants.PETMBINDINGCREATECHAIN, data);
    }
    public gettmname(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETTMNAME, data);
    }

    public petmbindinglist(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.PETMBINDINGLIST, data);
    }
    public peactionforbinding(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.PEACTIONFORBINDING, data);
    }

    //TM TA TD side
    public petmbindinglist_tmtatd(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.PETMBINDINGLIST_TMTATD, data);
    }

    public tmtatdactionforbinding(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.TMTATDACTIONFORBINDING, data);
    }

    public exportmtatdList(data: any): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.EXPORTTMTATDLIST, data, { responseType: "blob" });
    }

    public exportPeTmListCSV(data): Observable<any> {
        console.log("batch id issssssssssss", data)
        return this.http.post(APIConstants.DOWNLOADPETMCSVFILE, data, { responseType: "blob" });
    }

     //entity kyc and renewal update pradnya
     public entityKycUpdation(data): Observable<any> {
        console.log("dataaaaa", data)
        const headers = new HttpHeaders();
        headers.set('content-type', 'application/json');
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin', "*");
        return this.http.post(APIConstants.ENTITYKYCUPDATION, data, { headers });
    }
}